import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {AdminBusinessFilterIndicator} from './AdminBusinessFilterIndicator'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  isDisabled?: boolean
  activePaths?: string[]
  /** The pages under it follow an administrator's selected business: show the business-filter mark. */
  businessFilter?: boolean
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  isDisabled = false,
  activePaths = [],
  businessFilter = false,
}) => {
  const {pathname} = useLocation()
  const isActive =
    checkIsActive(pathname, to) || activePaths.some((path) => checkIsActive(pathname, path))
  const {config} = useLayout()
  const {app} = config

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          // Same size as SidebarMenuItem, so a group's icon lines up with the entries around it.
          <i className={clsx('fs-2 me-2', fontIcon, {'text-gray-800': isDisabled})}></i>
        )}
        {isDisabled ? (
          <span className='menu-title text-gray-800'>{title}</span>
        ) : (
          <span className='menu-title'>{title}</span>
        )}
        {businessFilter && <AdminBusinessFilterIndicator />}
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
